export default {
	meta: {
		title: 'Paiements',
		description: 'Paiements'
	},
	filters: {
		nationalAdmin: {
			to_pay: 'À payer',
			to_recycle: 'À recycler',
			paid: 'Payé',
			to_approve: 'À approuver',
			not_approved: 'Non approuvé',
			rejected: 'Rejeté'
		},
		liquidator: {
			to_pay: 'À payer',
			to_recycle: 'À recycler',
			paid: 'Payé',
			rejected: 'Rejeté'
		}
	},
	labelAllFilters: 'Tous les statuts',
	labelFiltersSelector: 'Filtrer par statut'
};
